<template>
	<div class="o-grid" v-if="scrollDisabled">
		<div class="o-grid__column" data-size="sm:12" v-if="heading">
			<h2 class="c-teaser-gallery__heading text-h2 heading-boarder t-margin--0-top">
				{{ heading }}
			</h2>
		</div>
		<div class="o-grid__column o-grid__column--heightauto c-teaser-gallery__group" data-size="sm:12 md:4 lg:4"
			v-for="(image, index) in images" :key="index">
			<v-object-development :image="image" :readMoreLabel="readMoreLabel" />
		</div>
	</div>
	<div class="o-grid " v-else>
		<div class="o-grid__column" data-size="sm:12" v-if="heading">
			<h2 v-if="heading" class="c-teaser-gallery__heading text-h2 heading-boarder t-margin--0-top">
				{{ heading }}
			</h2>
		</div>

		<div class="o-grid__column t-padding--0-right t-padding--0-left" data-size="sm:12 md:12 lg:12">
			<div :class="`c-teaser-gallery ${heading ? '' : 't-margin--1-top'}`
				">

				<v-gallery-image-scroller :is-links="isLinks" :hasTextBelow="hasTextBelow" :readMoreLabel="readMoreLabel"
					:images="images" :thumbnail-width="thumbnailWidth" :step-length="stepLength"
					:headingLevel="heading ? 'h3' : 'h2'">
					<template v-slot:intro>
						<slot name="intro"></slot>
					</template>
				</v-gallery-image-scroller>

				<div class="c-teaser-gallery__button" v-if="link && linkText">
					<a :href="link" class="c-button c-button--highlight c-button--icon">
						<span class="c-button--right">{{ linkText }}</span>
						<v-icon name="icon-chevron" size="xxs"></v-icon>
					</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
import VGalleryImageScroller from "../../components/gallery-image-scroller/VGalleryImageScroller.vue";
import VObjectDevelopment from "../../components/object-listing/object-development/VObjectDevelopment.vue";
export default {
	name: "VTeaserGallery",
	components: {
		VGalleryImageScroller,
		VObjectDevelopment,
		VIcon
	},
	props: {
		heading: {
			type: String
		},
		introText: {
			type: String
		},
		link: {
			type: String
		},
		linkText: {
			type: String
		},
		isLinks: {
			type: Boolean,
			default: true
		},
		readMoreLabel: {
			type: String,
			default: "Läs mer"
		},
		hasTextBelow: {
			type: Boolean,
			default: true
		},
		images: {
			type: Array,
			default: () => []
		},
		thumbnailWidth: {
			type: Number,
			default: 28
		},
		stepLength: {
			type: Number,
			default: 1
		},
		scrollDisabled: { type: Boolean, default: false },
		className: {
			type: String
		}
	},
	data() {
		return {};
	},
	computed: {},
	methods: {}
};
</script>
